const digitalPayWarningDisplayComponentDefinition = {
    template: require('./digital-pay-warning-display.component.html').trim(),
    bindings: {
        warningMessage: '<',
        isThinStyle: '<',
    },
};

module.exports = {
    digitalPayWarningDisplayComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/error/digital-pay-warning-display.component.js